import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { InvestmentCompaniesParams, InvestmentCompany } from '../investment-companies.interface';

export const setInvestmentCompanies = createAction(
  '[Investment Companies Component] Set Investment Companies',
  props<{ investmentCompanies: BackendResponse<InvestmentCompany>; params: InvestmentCompaniesParams; pageNumber: number }>()
);

export const updateManyInvestmentsCompanies = createAction(
  '[Investment Companies Component] Update Many Investment Companies',
  props<{ investmentCompanies: { ids: string[]; changes: Partial<InvestmentCompany> } }>()
);

export const updateInvestmentCompanies = createAction(
  '[Investment Companies Component] Update Investment Companies',
  props<{ investmentCompanies: InvestmentCompany[] }>()
);

export const switchSelection = createAction('[Investment Comapnies Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Investment Companies Component] Switch All Selection', props<{ checked: boolean }>());

// Requests

export const changeInvestmentCompaniesFlags = createAction(
  '[Request/Api Investment Companies] Change Investment Companies Flags',
  props<{ payload: { ids: string[]; red: string } }>()
);

export const loadInvestmentCompanies = createAction(
  '[Request/Api Investment Companies] Load Investment Companies',
  (params: InvestmentCompaniesParams, pageNumber: number = 1) => ({ params, pageNumber })
);
